// initialed state

export const initialState = () => ({
	loadingProcesses: false,
	processes: [],
	loadingSelectedProcess: false,
	selectedProcess: null,
});

export default initialState();
